<template>
  <div
    class="pc-layout"
    :style="mainContentWidth"
  >
    <header
      ref="headerRef"
      class="pc-layout__header"
    >
      <WebAuthInfo v-if="!showCeiling" />
      <div
        class="search-ceiling"
        :class="{ ceiling: showCeiling, 'ceiling-up': scrollDirection === 'up', 'ceiling-down': scrollDirection === 'down' }"
      >
        <Search
          :show-ceiling="showCeiling"
          :guidance-pop-visible="guidancePopVisible"
        />
        <CategorySlider />
      </div>
    </header>
    <div
      v-if="showCeiling"
      :style="{ height: headerHeight + 'px' }"
    />
    <section
      class="pc-layout__content"
    >
      <RouterView />
    </section>
    <Footer />
  </div>
  <!-- 仅在详情页展示 -->
  <div
    v-if="isDetailPage && sideCartVisible"
    style="max-width: 144px;"
  >
    <PCSideCart />
  </div>
  <NewbieGuidance
    :pop-visible="guidancePopVisible"
    :title="currentGuidance.title"
    :video-src="currentGuidance.videoSrc"
    @close="closeGuidancePop"
  />
  <Toast
    :msg="toastInfo.msg"
    :type="toastInfo.type"
    :visible="toastVisible"
  />
  <LoginModal position="center" />

  <AddressDialog />

  <PCDropshippingDialog />
</template>

<script setup>
import { computed, onMounted, ref, onBeforeUnmount, nextTick } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import WebAuthInfo from './components/WebAuthInfo.vue'
import Search from '@/components/Search/index.vue'
import CategorySlider from '@/components/CategorySlider/index.vue'
import Footer from '@/components/Footer/index.vue'
import NewbieGuidance from '@/components/NewbieGuidance/index.vue'
import Toast from '@/components/Toast/index.vue'
import { LoginModal } from '@/components/Login'
import { buriedPointUtil, gaAnalytics } from '@/utils/utils'
import { useUserStore } from '@/pinia/user'
import PCSideCart from '@/components/PCSideCart/index.vue'
import { useCartStore } from '@/pinia/cart'
import { AddressDialog } from '@/components/AddressDialog'
import { usePcSideCart } from '@/components/PCSideCart/usePcSideCart'
import { PCDropshippingDialog } from '@/components/Dropshipping'

const store = useStore()
const route = useRoute()

const user = useUserStore()

const cart = useCartStore()

const { visible: sideCartVisible } = usePcSideCart()

const showCeiling = ref(false)
const headerRef = ref(null) // 创建 ref 引用
const headerHeight = ref(0)

const lastScrollY = ref(0)
const scrollDirection = ref('')

const isCollapseSideCart = computed(() => !cart.expand)

const guidancePopVisible = computed(
  () => store.state.common.guidancePopVisible
)
const currentGuidance = computed(() => store.state.common.currentGuidance)
const toastVisible = computed(() => store.state.common.toastVisible)
const toastInfo = computed(() => store.state.common.toastInfo)

const isDetailPage = computed(() => route.path.includes('/offer'))

const mainContentWidth = computed(() => {
  if (!isDetailPage.value) return {}

  let width = 0
  if (sideCartVisible.value) {
    width = isCollapseSideCart.value ? '80px' : '144px'
  } else {
    width = '0px'
  }

  return {
    width: `calc(100vw - ${width})`
  }
})

const closeGuidancePop = () => {
  store.commit('common/SET_GUIDANCE_POP_VISIBLE', false)
}

// 用于判断滚动时头部是否显示
const layoutOnScroll = () => {
  // 详情页滚动 暂时隐藏头部
  if (route.path.includes('/offer')) {
    return
  }
  // Ai 文搜隐藏头部
  if (route.name === 'search' && route.query.keyword && route.query.categoryId == null && !route.query.isAISearched) return

  const pageScrollY = window.scrollY

  if (pageScrollY > headerHeight.value + 20) {
    if (pageScrollY > lastScrollY.value) {
      scrollDirection.value = 'down' // 向下滚动

      lastScrollY.value = pageScrollY
    } else if (pageScrollY < lastScrollY.value - 120) {
      scrollDirection.value = 'up' // 向上滚动
      showCeiling.value = true // 显示 ceiling

      lastScrollY.value = pageScrollY
    }
  } else {
    showCeiling.value = false // 隐藏 ceiling
    scrollDirection.value = ''
  }
}

onMounted(async () => {
  // 监听 windows 滚动
  window.addEventListener('scroll', layoutOnScroll)
  gaAnalytics('p_page_view', 'p_page_view', {
    bdUserId: user.userInfo.uid
  })
  buriedPointUtil({ eventId: 'PWH501' })

  nextTick(() => {
    if (headerRef.value) {
      headerHeight.value = headerRef.value.offsetHeight // 获取高度
    }
  })
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll', layoutOnScroll)
})
</script>

<style lang="less" scoped>
.pc-layout {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 1024PX;
  // overflow-x: auto;
  // overflow-y: hidden;

  &__content {
    flex: 1;
    /** 设置 content 为 flex，使子元素通过 flex: 1 继承到该元素的最小高度 */
    display: flex;
    flex-direction: column;
  }
}

.ceiling {
  position: fixed;
  left: 0;
  right: 0;
  z-index: 999;
  visibility: hidden;
  opacity: 0;
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
}

.ceiling-up {
  visibility: initial;
  opacity: 1;
  transform: translateY(0px);
}

.ceiling-down {
  visibility: initial;
  opacity: 0;
  transform: translateY(-100%);
}
</style>
